import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoEllipseCircleHorizontal = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>EllipseCircleHorizontal</title>
    <circle
      cx={15.998}
      cy={16.997}
      r={12.722}
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx={9.257} cy={16.998} r={1.714} fill="currentColor" />
    <circle cx={22.974} cy={16.998} r={1.714} fill="currentColor" />
    <circle cx={16.115} cy={16.998} r={1.714} fill="currentColor" />
  </svg>
);
export default SvgIcoEllipseCircleHorizontal;
